
import React from "react";

type SearchStep = 'initial' | 'cep-found' | 'location-found' | 'complete';

interface SearchStepIndicatorProps {
  searchStep: SearchStep;
}

export const SearchStepIndicator = ({ searchStep }: SearchStepIndicatorProps) => {
  if (searchStep === 'initial') return null;
  
  return (
    <div className="my-3 bg-green-50 p-3 rounded-lg border border-green-200">
      <div className="flex gap-2 justify-center">
        <div className="flex items-center gap-2">
          <div className={`w-6 h-6 rounded-full flex items-center justify-center ${
            searchStep === 'cep-found' || searchStep === 'location-found' || searchStep === 'complete' 
              ? 'bg-green-500 text-white' 
              : 'bg-gray-300'
          }`}>1</div>
          <span className={`text-sm ${
            searchStep === 'cep-found' || searchStep === 'location-found' || searchStep === 'complete' 
              ? 'text-green-700 font-medium' 
              : 'text-gray-500'
          }`}>CEP localizado</span>
        </div>
        
        <div className="w-4 h-0.5 bg-gray-200 self-center"></div>
        
        <div className="flex items-center gap-2">
          <div className={`w-6 h-6 rounded-full flex items-center justify-center ${
            searchStep === 'location-found' || searchStep === 'complete' 
              ? 'bg-green-500 text-white' 
              : 'bg-gray-300'
          }`}>2</div>
          <span className={`text-sm ${
            searchStep === 'location-found' || searchStep === 'complete' 
              ? 'text-green-700 font-medium' 
              : 'text-gray-500'
          }`}>Irradiação calculada</span>
        </div>
        
        <div className="w-4 h-0.5 bg-gray-200 self-center"></div>
        
        <div className="flex items-center gap-2">
          <div className={`w-6 h-6 rounded-full flex items-center justify-center ${
            searchStep === 'complete' 
              ? 'bg-green-500 text-white' 
              : 'bg-gray-300'
          }`}>3</div>
          <span className={`text-sm ${
            searchStep === 'complete' 
              ? 'text-green-700 font-medium' 
              : 'text-gray-500'
          }`}>HSP calculado</span>
        </div>
      </div>
    </div>
  );
};
